
/* eslint-disable */
// Autogenerated
// -------------
// gulpfile.ts/wasm.ts --> generateBuildInfo

export const Build = {
    version: "8.1.9 (34a08e4c41ba7b5e93d56c9854e0c42f)",
    buildSeed: 1724941289131,
    "wdosbox-x.wasm": {
        "size": 6304319,
        "gzSize": 2294354
    },
    "wdosbox-x.js": {
        "size": 230427,
        "gzSize": 54623
    },
    "wdosbox.wasm": {
        "size": 1467793,
        "gzSize": 499747
    },
    "wdosbox.js": {
        "size": 108170,
        "gzSize": 28965
    },
    "wlibzip.wasm": {
        "size": 112416,
        "gzSize": 52241
    },
    "wlibzip.js": {
        "size": 74095,
        "gzSize": 19630
    }
,
};
